import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initAnalytics } from "./analytics";
import { install3dAssetAliases } from "./render3d/assetAliases";
import { runOptionalStartup } from "./startup";
import "./ui/global.css";
import "./ui/authOverrides.css";

runOptionalStartup(install3dAssetAliases);
runOptionalStartup(initAnalytics);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
